import { Link } from "react-router-dom";
import { useRouteLocale } from "@/hooks/useRouteLocale";
import { usePageMeta } from "@/hooks/usePageMeta";
import { Button } from "@/components/ui/button";
import { useTranslation } from "@/hooks/useTranslation";
import { PublicContentLayout } from "@/components/public/PublicContentLayout";
import { PUBLIC_ROUTES } from "@/routes/public";

/**
 * Public not-found page (JUB-184). Rendered for unknown paths under /ro and
 * /en (the `*` route of each locale block, and the legacy `/{locale}/{slug}`
 * event route once the slug is known not to exist) and for paths outside the
 * locale prefixes. Shares the public header and footer so a guest who followed
 * a stale link still sees the site, and names itself in the tab.
 */
export default function NotFound() {
  const { t } = useTranslation();
  // Literal /ro, /en route prefixes: the locale is in the path, not in useParams().
  const locale = useRouteLocale();

  usePageMeta({
    title: t("httpErrors.404.metaTitle"),
    description: t("httpErrors.404.message"),
    locale,
    path: window.location.pathname,
    noindex: true,
  });

  return (
    <PublicContentLayout>
      <div className="py-16 text-center space-y-6" data-testid="not-found-page">
        <h1 className="text-6xl font-bold text-primary">{t("httpErrors.404.title")}</h1>
        <p className="text-xl text-muted-foreground">{t("httpErrors.404.message")}</p>
        <Link to={PUBLIC_ROUTES.home(locale)} className="inline-block">
          <Button>{t("httpErrors.404.backHome")}</Button>
        </Link>
      </div>
    </PublicContentLayout>
  );
}
